import { GatsbyImage as _GastbyImage } from 'gatsby-plugin-image'
import { isEmpty } from 'lodash'
import React, { memo } from 'react'

const GatsbyImage = (props) => {
  const { image } = props

  const prop = { alt: '', ...props }
  if (!image || isEmpty(image)) {
    return null
  }
  return <_GastbyImage {...prop} />
}

export default memo(GatsbyImage)
